/**
 * Created by jonas on 2022-06-15.
 */
import {SimplePresentation, SimplePresentationRunnerController} from "../winpresentation/SimplePresentationRunner";
import {KitchenDramaSushiManiaReelsView} from "../reels/KitchenDramaSushiManiaReelsView";
import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";
import {gsap} from "gsap";
import {KitchenDramaSushiManiaSound} from "../sound/KitchenDramaSushiManiaSound";

export class CollapseAndFillPresentation implements SimplePresentation {
    name:string = "CollapseAndFillPresentation";
    private roundIndex:number;

    constructor(index:number) {
        this.roundIndex = index;
    }

    shouldRun():boolean {
        return true;
    }

    start(controller:SimplePresentationRunnerController):void {
        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => controller.finish()});
        const delay = KitchenDramaSushiManiaReelsView.reelDropDelay;
        tl.add(KitchenDramaSushiMania.reelView.reelModels[0].collapseAndFill(KitchenDramaSushiMania.model.gameData.reels[this.roundIndex][0]),0);
        tl.add(KitchenDramaSushiMania.reelView.reelModels[1].collapseAndFill(KitchenDramaSushiMania.model.gameData.reels[this.roundIndex][1]),0);
        tl.add(KitchenDramaSushiMania.reelView.reelModels[2].collapseAndFill(KitchenDramaSushiMania.model.gameData.reels[this.roundIndex][2]),0);
        tl.add(KitchenDramaSushiMania.reelView.reelModels[3].collapseAndFill(KitchenDramaSushiMania.model.gameData.reels[this.roundIndex][3]),0);
        tl.add(KitchenDramaSushiMania.reelView.reelModels[4].collapseAndFill(KitchenDramaSushiMania.model.gameData.reels[this.roundIndex][4]),0);

        tl.add(()=>KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.SYMBOLS_LANDING), 0.6);

    }
}